import React, { useState, useEffect, useRef } from "react" ;
import axios from 'axios'
import PaypalCheckoutMain from "./PaypalCheckoutMain";

const PaypalCheckoutHSK3 = () => {
   
    return (
       <PaypalCheckoutMain
        amountTotal="31.00"
        hsk="_hsk3"
        hskNumber="3"
      />
    );
}

export default PaypalCheckoutHSK3